import React from "react";
import { ArrowRightOutlined } from "@ant-design/icons";

const LatestVideos = ({ videos, isMobile }) => {
  const handleVideoClick = (youtubeUrl) => {
    window.open(youtubeUrl, "_blank");
  };

  return (
    <div
      style={{
        backgroundColor: "#F7F7F7",
        borderRadius: "0px",
        paddingTop: isMobile ? "20px" : "30px",
        paddingBottom: isMobile ? "20px" : "100px",
        padding: isMobile ? "20px 16px" : "0 24px",
        maxWidth: "100%",
        margin: "0 auto",
      }}
    >
      <h2
        style={{
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "700",
          color: "#000",
          marginBottom: isMobile ? "16px" : "20px",
          textAlign: "left",
        }}
      >
        Latest Videos
      </h2>

      <VideosGrid 
        videos={videos} 
        isMobile={isMobile} 
        onVideoClick={handleVideoClick} 
      />
    </div>
  );
};

const VideosGrid = ({ videos, isMobile, onVideoClick }) => {
  if (isMobile) {
    return (
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
        {videos.map((video, idx) => (
          <VideoTile 
            key={idx} 
            video={video} 
            isMobile={isMobile} 
            onClick={onVideoClick} 
          />
        ))}
      </div>
    );
  }

  return (
    <div style={{ display: "flex", gap: "20px", justifyContent: "space-between", flexWrap: "nowrap" }}>
      {videos.map((video, idx) => (
        <VideoTile 
          key={idx} 
          video={video} 
          isMobile={isMobile} 
          onClick={onVideoClick} 
        />
      ))}
    </div>
  );
};

const VideoTile = ({ video, isMobile, onClick }) => (
  <div
    className={isMobile ? "mobile-video-tile" : "video-tile"}
    style={{
      ...(isMobile ? {
        textAlign: "left",
        border: "1px solid rgba(130, 130, 130, 0.5)",
        overflow: "hidden",
        backgroundColor: "#fff",
        borderRadius: "12px",
        cursor: "pointer",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
      } : {
        flex: "1 1 0",
        textAlign: "left",
        border: "1px solid rgba(75,75,75,0.5)",
        overflow: "hidden",
        backgroundColor: "#fff",
        cursor: "pointer",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
        position: "relative",
      }),
    }}
    onClick={() => onClick(video.youtubeUrl)}
  >
    <div className={isMobile ? "mobile-video-image-container" : "video-image-container"}>
      <img
        src={video.img}
        alt={video.name}
        className={isMobile ? "mobile-video-image" : "video-image"}
        style={{
          width: "100%",
          height: isMobile ? "100px" : "200px",
          objectFit: "cover",
          display: "block",
          transition: "all 0.3s ease",
        }}
      />
      <div className={isMobile ? "mobile-video-overlay" : "video-overlay"}>
        <div className={isMobile ? "mobile-play-button" : "play-button"}>
          <svg 
            width={isMobile ? "32" : "48"} 
            height={isMobile ? "32" : "48"} 
            viewBox={isMobile ? "0 0 32 32" : "0 0 48 48"} 
            fill="none"
          >
            <circle cx={isMobile ? "16" : "24"} cy={isMobile ? "16" : "24"} r={isMobile ? "16" : "24"} fill="rgba(0,0,0,0.6)"/>
            <path d={isMobile ? "M22 16L14 22V10L22 16Z" : "M32 24L20 32V16L32 24Z"} fill="white"/>
          </svg>
        </div>
      </div>
    </div>
    <div style={{ padding: isMobile ? "8px" : "16px" }}>
      <p
        style={{
          color: "#000",
          fontSize: isMobile ? "12px" : "16px",
          marginBottom: isMobile ? "4px" : "6px",
          lineHeight: isMobile ? "1.3" : "1.4",
          fontWeight: "600",
        }}
      >
        {video.name}
      </p>
      <span
        style={{
          color: "#4B4B4B",
          fontWeight: "600",
          cursor: "pointer",
          fontSize: isMobile ? "11px" : "14px",
          display: "flex",
          alignItems: "center",
          gap: isMobile ? "2px" : "4px",
        }}
      >
        Watch Now <ArrowRightOutlined style={{ fontSize: isMobile ? "10px" : "12px" }} />
      </span>
    </div>
  </div>
);

export default LatestVideos;